'use client';

import Image from "next/image";

type FeatureSectionProps = {
  features: Array<{
    description: string;
    image?: string;
  }>;
  featuresLength: number;
};

export function FeatureSection({ features, featuresLength }: FeatureSectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
      {features.map((item, i) => {
        return (
          <div
            key={i}
            className={`
              bg-gray-100 rounded-xl p-6 flex flex-col
              ${featuresLength === 5 && i >= 3 ? "md:col-span-6 lg:col-span-3" : "md:col-span-2 lg:col-span-2"}
            `}
          >
            {item.image && (
              <Image
                src={item.image}
                alt={item.description || "feature icon"}
                width={100}
                height={100}
                className="mb-4"
              />
            )}
            <p className="text-gray-700">{item.description}</p>
          </div>
        );
      })}
    </div>
  );
}
